<div class="message-popup" style="display: {{#isVisible}} block {{/isVisible}} {{^isVisible}} none {{/isVisible}}">
  <div class="message-popup__modal"></div>
  <div class="message-popup__container">
    <div class="message-popup__title">
      {{{title}}}
    </div>
    <div class="message-popup__body">
      <div class="message-popup__message">
        {{{message}}}
      </div>
    </div>
    <div class="message-popup__footer">
      {{#hasConfirm}}
      <a class="message-popup__btn message-popup__btn--confirm" href="#" data-callback="onConfirm"
        onclick="return false;">{{confirmText}}</a>
      {{/hasConfirm}}
      {{#hasCancel}}
      <a class="message-popup__btn message-popup__btn--cancel" href="#" data-callback="onCancel"
        onclick="return false;">{{cancelText}}</a>
      {{/hasCancel}}
      <!-- <a class="message-popup__btn message-popup__btn--important" href="#">중요한 버튼</a> -->
    </div>
  </div>
</div>